export default __webpack_public_path__ + "static/gamerize-3-d-08b57176adc2aa9004551a2a7a6511b4.webp";